import { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Introduction } from './components/Introduction';
import { Skills } from './components/Skills';
import { Education } from './components/Education';
import './style.css';
import Typed from 'typed.js';

function App() {
  useEffect(() => {
    const typed = new Typed('.multiple-text', {
      strings: ['Full Stack Web Developer','React Developer','Data Analyst' , 'Python Developer', 'Cyber Security'],
      typeSpeed: 100,
      backSpeed: 100,
      backDelay: 1000,
      loop: true
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      <Navbar />
      <Introduction />
      <Skills />
      <Education />
    </>
  );
}

export default App;